// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1Z213m","title":"hps71s","subtitleBox":"_3cb_oL","inChronicle":"_24bk2C","navigationItemsBox":"vz2dZ0"};